var Marionette = require('marionette'),
    WordView = require('./word');


module.exports = Marionette.CollectionView.extend({

    childView: WordView,

    childViewOptions: function( ) {

        return {
            spacer: this.options.spacer
        };

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/wordLayer/wordLayer.js
 ** module id = 446
 ** module chunks = 0
 **/